<template>
  <div>
    <div>
      <div class="vx-row justify-end mb-4">
        <div class="vx-col">
          <vs-button
            @click="onClickAdd"
          >
            登録
          </vs-button>
        </div>
      </div>
      <v-expansion-panels v-model="openingPanel">
        <v-expansion-panel value="panel1">
          <v-expansion-panel-title class="bg-white border-transparent">
            レポート一覧
            <template v-slot:actions="{expanded}">
              <VueFeather
                :type="expanded ? 'chevron-up' : 'chevron-down' "
                class="feather-icon feather-icon-css-target inline-flex"
              />
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <data-table
              :column-defs="columnDefs"
              :default-col-def="defaultColDef"
              :row-data="reportConfigs"
              :grid-options="gridOptions"
              pagination
            />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div>
      <form-modal
        v-model="showForm"
        title="ブランドレポートの登録"
        submit-button-text="登録"
        class="amc-brand-report-modal"
        @click:submit="onClickSubmit"
      >
        <template #content>
          <ValidationForm
            ref="amcBrandReportFormObserver"
          >
            <AmcBrandReportForm
              v-model:report-type="config.reportType"
              v-model:report-name="config.reportName"
              v-model:order="config.order"
              v-model:line-item="config.lineItem"
              v-model:segment="config.segment"
              v-model:category="config.category"
              v-model:categories="config.categories"
              v-model:before-date="config.startDate"
              v-model:after-date="config.endDate"
              v-model:reach-type="config.reachType"
              :min-date="minDate"
              :max-date="maxDate"
              :isEdit="isEdit"
              class="mb-10"
              ref="amcBrandReportForm"
              @update:report-type="onChangeReportType"
              @update:category="onChangeCategory"
            />
          </ValidationForm>
        </template>
      </form-modal>
    </div>
    <div class="mt-4">
      <div v-for="(_, index) in Math.ceil(reports.length / 2)" :key="index" class="vx-row">
        <div v-for="(item, itemIndex) in reports.slice(index * 2, index * 2 + 2)" :key="itemIndex" class="vx-col w-1/2 mt-2">
          <vx-card>
            <div class="vx-row flex-no-wrap justify-between mb-2">
              <div class="vx-col overflow-x-auto text-no-wrap">
                {{ item.reportName }}
              </div>
              <div class="vx-col vx-row flex-no-wrap">
                <div v-if="item.reportType === 12" class="vx-col w-48">
                  <select-field
                    v-model="selectedSeries[item.id]"
                    name="系列"
                    :options="[{text:'CTR', value:'ctr'}, {text:'DPVR', value:'dpvr'}, {text:'CVR', value:'cvr'}]"
                    :allow-empty="false"
                    full-width
                  />
                </div>
                <div class="vx-col">
                  <vs-button
                    @click="onClickDownload(item)"
                    class="px-4 pt-2 pb-1"
                  >
                  <VueFeather
                    type="download"
                    size="1.25rem"
                  />
                  </vs-button>
                </div>
              </div>
            </div>
            <!-- グラフ -->
            <div v-if="item.reportType === 7">
              <OrderRateChart
                :report="item.data"
                :height="400"
              />
            </div>
            <div v-else-if="item.reportType === 8">
              <ReachFrequencyChart
                :report="item.data"
                :height="400"
              />
            </div>
            <div v-else-if="item.reportType === 9">
              <ReachCoverageChart
                :report="item.data"
                :height="400"
              />
            </div>
            <div v-else-if="item.reportType === 12">
              <FrequencyPerformanceChart
                :report="item.data"
                :height="400"
                :selectedSeries="selectedSeries[item.id]"
                :reachType="item.reachType"
              />
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <confirm-modal
      v-model="showConfirmModal"
      title="ブランドレポート削除"
      @click:confirm="onClickDeleteConfirm"
      @click:cancel="showConfirmModal = false"
    >
      <template #content>
        <p class="p-4 whitespace-pre-wrap">
          レポート名 {{ `${deleteTarget.name}` }} を本当に削除しますか？
        </p>
      </template>
    </confirm-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex'
import DataTable from '@/components/table/DataTable'
import DataTableCellActions from '@/components/table/DataTableCellActions'
import DataTableCellSwitch from '@/components/table/DataTableCellSwitch'
import FormModal from '@/components/modals/FormModal'
import ConfirmModal from '@/components/modals/ConfirmModal'
import SelectField from '@/components/fields/SelectField'
import AmcBrandReportForm from '@/components/forms/AmcBrandReportForm'
import OrderRateChart from '@/user/components/charts/OrderRateChart'
import ReachCoverageChart from '@/user/components/charts/ReachCoverageChart'
import ReachFrequencyChart from '@/user/components/charts/ReachFrequencyChart'
import FrequencyPerformanceChart from '@/user/components/charts/FrequencyPerformanceChart'
import AMC_REPORT_TYPE from '@/constants/AmcReportType'

export default {
  components: {
    DataTable,
    FormModal,
    ConfirmModal,
    SelectField,
    AmcBrandReportForm,
    OrderRateChart,
    ReachCoverageChart,
    ReachFrequencyChart,
    FrequencyPerformanceChart
  },
  data () {
    return {
      openingPanel: [],
      ENABLE_LIMIT: 10,  // レポート有効可能数
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: false,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'アクション',
          cellRenderer: 'dataTableCellActions',
          cellRendererParams: {
            editable: true,
            deletable: true,
            onClickEdit : this.onClickEdit,
            onClickTrash: this.onClickTrash
          },
        },
        {
          headerName: 'ステータス',
          field: 'enabled',
          cellRenderer: 'dataTableCellSwitch',
          cellRendererParams : {
            action : this.onSwitchChange.bind(this)
          },
        },
        {
          headerName: 'レポート名',
          field: 'reportName'
        },
        {
          headerName: 'レポート種類',
          field: 'reportType',
          valueFormatter: (params) => {
            return AMC_REPORT_TYPE[params.value]
          }
        },
        {
          headerName: '開始日',
          field: 'startDate'
        },
        {
          headerName: '終了日',
          field: 'endDate'
        },
        {
          headerName: '最終更新日',
          field: 'lastUpdated'
        }
      ],
      gridOptions: {},
      showConfirmModal: false,
      editId: -1, // 編集対象ID
      deleteTarget: {name: '', id: null},
      showForm: false,
      config: {
        reportType: null,
        reportName: null,
        order: [],
        lineItem: [],
        segment: null,
        category: null,
        categories: [],
        startDate: null,
        endDate: null,
        reachType: null
      },
      minDate: null,
      maxDate: null,
      selectedSeries: {},
    }
  },
  computed: {
    ...mapState('amcBrandReports', ['reportConfigs', 'reports', 'minStartDay']),
    ...mapState('account', ['activeAccount']),
    ...mapGetters('amcBrandReports', ['enabledCount']),
    canEnable () {
      return !(this.enabledCount >= this.ENABLE_LIMIT)
    },
    isEdit () {
      return this.editId !== -1
    }
  },
  beforeMount () {
    this.gridOptions = {
      autoSizeStrategy: {
        type: 'fitCellContents'
      },
      components: {
        dataTableCellActions: DataTableCellActions,
        dataTableCellSwitch: DataTableCellSwitch
      }
    }
    if (Number(this.activeAccount.activeReportLimit) > 0) {
      this.ENABLE_LIMIT = Number(this.activeAccount.activeReportLimit)
    }
  },
  async mounted () {
    await Promise.all([
      this.listBrandReport(),  // 一覧
      this.fetchReports(),  // グラフ
      this.listCampaign(), // 以下オプション
      this.listLineItem(),
      this.listSegment(),
      this.listCategories(),
      this.fetchMinStartDay()
    ]);
    this.minDate = moment(this.minStartDay).toDate()  // amc_report_ad_campaignのMIN(cost_month)
    this.maxDate = moment().add(3, 'months').toDate()  // 今日から3ヶ月
    // FQ別パフォーマンスグラフのパラメータ初期化
    if (this.reports.length > 0) {
      for (const r of this.reports) {
        if (r.reportType === 12) {
          this.selectedSeries[r.id] = 'ctr'
        }
      }
    }
  },
  methods: {
    ...mapActions('amcBrandReports', ['listBrandReport','listCampaign','listLineItem','listSegment','listCategories','fetchMinStartDay','fetchReports','downloadCSV','updateEnabled','updateBrandReport','deleteBrandReport','addBrandReport']),
    async onClickAdd () {
      this.editId = -1
      if( !this.canEnable ) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          text: `有効にできるレポートの上限は${this.ENABLE_LIMIT}個です。${this.ENABLE_LIMIT - 1}個以下にしてから再度お試しください。`,
          fixed: true
        })
        return
      }
      this.openingPanel = ['panel1']
      this.config.reportType = null  // レポート種類だけ初期化（onChangeReportTypeを介さずに）
      await this.$refs.amcBrandReportFormObserver.resetForm()
      this.showForm = true
    },
    async onClickEdit ({index}) {
      const target = structuredClone(this.reportConfigs[index])
      this.editId = target['id']

      this.config.reportType = null
      await this.initialize()
      this.config.reportType = {text: AMC_REPORT_TYPE[target.reportType] , value: target.reportType}
      this.config.reportName = target.reportName
      this.config.startDate =  target.startDate
      this.config.endDate =  target.endDate
      if (target.params.hasOwnProperty('order')) {
        this.config.order = target.params.order
      }
      if (target.params.hasOwnProperty('lineItem')) {
        this.config.lineItem = target.params.lineItem
      }
      if (target.params.hasOwnProperty('segment')) {
        this.config.segment = target.params.segment
      }
      if (target.params.hasOwnProperty('category')) {
        this.config.category = target.params.category
      }
      if (target.params.hasOwnProperty('categories')) {
        this.config.categories = target.params.categories
      }
      if (target.params.hasOwnProperty('reachType')) {
        this.config.reachType = target.params.reachType
      }
      this.showForm = true
    },
    async onClickTrash ({index}) {
      this.deleteTarget.name = this.reportConfigs[index].reportName
      this.deleteTarget.id = this.reportConfigs[index].id
      this.showConfirmModal = true
    },
    async onClickDeleteConfirm () {
      try {
        await this.deleteBrandReport({reportId: this.deleteTarget.id})
        this.showConfirmModal = false
        this.listBrandReport()
      } catch (e) {
        console.log(e)
      }
    },
    async onSwitchChange ({index, value}) {
      if (value) {
        if ( !this.canEnable ) {
          this.$vs.notify({
            position: 'top-center',
            color: 'danger',
            text: `有効にできるレポートの上限は${this.ENABLE_LIMIT}個です。${this.ENABLE_LIMIT - 1}個以下にしてから再度お試しください。`,
            fixed: true
          })
          return
        } 
      }
      const target = this.reportConfigs[index]
      await this.updateEnabled({reportId: target.id, value})
      await this.listBrandReport()
    },
    async onClickSubmit () {
      try {
        const result = await this.$refs.amcBrandReportFormObserver.validate()
        if (!result.valid) return
        const data = {
          reportName: this.config.reportName,
          reportType: this.config.reportType.value,
          startDate: this.config.startDate,
          endDate: this.config.endDate,
          params: this.transformParams()
        }
        if (this.editId === -1) {  // 編集か新規登録か
          await this.addBrandReport(data)
        } else {
          await this.updateBrandReport({ reportId: this.editId, ...data})
        }
        this.showForm = false
        window.setTimeout(async () => {
          await this.initialize()
        }, 200)
        this.listBrandReport()
      } catch (e) {
        console.log(e)
      }
    },
    transformParams () {
      let params = {}
      if (this.config.order.length > 0) {
        params.order = this.config.order
      }
      if (this.config.lineItem.length > 0) {
        params.lineItem = this.config.lineItem
      }
      if (this.config.segment) {
        params.segment = this.config.segment
      }
      if (this.config.category && this.config.categories.length > 0) {
        params.category = this.config.category
        params.categories = this.config.categories
      }
      params.reachType = this.config.reachType
      return params
    },
    async onClickDownload (report) {
      try {
        await this.downloadCSV({id: report.id, reportType: report.reportType, reportName: report.reportName})
      } catch (e) {
        console.log(e)
      }
    },
    async onChangeReportType () {
      await this.initialize()
    },
    onChangeCategory () {
      this.config.categories = []
    },
    async initialize () {
      this.config.reportName = null
      this.config.order = []
      this.config.lineItem = []
      this.config.segment = null
      this.config.category = null
      this.config.categories = []
      this.config.startDate = null
      this.config.endDate = null
      this.config.reachType = null
      await this.$refs.amcBrandReportFormObserver.resetForm()
    }
  }
}
</script>

<style scoped>
.amc-brand-report-modal :deep(.vs-popup--content):has(.no-category-selected) {
  overflow: visible !important;
}
</style>
